import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import { Section, VStack } from 'tio-ui/components/layout';
import type SessionContextService from 'tio-employee/services/session-context';

interface S {
  Args: {
    model: {
      id: string;
    };
  };
}

class ReportingIndexRoute extends Component<S> {
  @service declare sessionContext: SessionContextService;

  get companyId() {
    return this.sessionContext.currentRole?.company.id;
  }

  <template>
    {{pageTitle (t "reporting.reports")}}
    <VStack>
      {{#if this.companyId}}
        <Section>
          <:header>{{t "reporting.reports"}}</:header>
          <:body>
            <p>{{t "reporting.no_reports"}}</p>
          </:body>
        </Section>
      {{/if}}
    </VStack>
  </template>
}

export default ReportingIndexRoute;
